module.exports = __webpack_public_path__ + "static/gerda-51f05425d58fc8a34f8e87c238844175.mp3";